/**
 * @generated SignedSource<<428d5d05389190f3430e2e55e0611abb>>
 * @relayHash 489e47f009d264a94dcf13fd8bbf4da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceInlineMarkerType = "COMMENT" | "REACTION" | "%future added value";
export type useActiveInlineDataActiveInlineDataQuery$variables = {
  cloudId: string;
  contentId: string;
};
export type useActiveInlineDataActiveInlineDataQuery$data = {
  readonly confluence_activeInlineData: {
    readonly reactions: ReadonlyArray<{
      readonly commentId: string;
      readonly markerRef: string;
      readonly type: ConfluenceInlineMarkerType;
    } | null>;
  } | null;
};
export type useActiveInlineDataActiveInlineDataQuery = {
  response: useActiveInlineDataActiveInlineDataQuery$data;
  variables: useActiveInlineDataActiveInlineDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluenceActiveInlineData",
    "kind": "LinkedField",
    "name": "confluence_activeInlineData",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceInlineMarker",
        "kind": "LinkedField",
        "name": "reactions",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "commentId"
          },
          {
            "kind": "ScalarField",
            "name": "markerRef"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useActiveInlineDataActiveInlineDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useActiveInlineDataActiveInlineDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "489e47f009d264a94dcf13fd8bbf4da5",
    "id": "bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515",
    "metadata": {},
    "name": "useActiveInlineDataActiveInlineDataQuery",
    "operationKind": "query",
    "text": "query useActiveInlineDataActiveInlineDataQuery($cloudId:ID!,$contentId:ID!){confluence_activeInlineData(cloudId:$cloudId,contentId:$contentId){reactions{commentId,markerRef,type}}}"
  }
};
})();

(node as any).hash = "1068a88ea8d0dcc33a5206b8fda71604";

export default node;
